<template>
<div class="col-12 px-0"> 
    <el-table :data="tableData" style="width: 100%" @row-click="gotoDetails">
        <el-table-column prop="name" sortable :sort-method="sortColumnName" label="grupo econômico" min-width="100">
            <template slot-scope="scope">
                <div class="d-flex align-items-center">
                    <NameInitials :name="scope.row.name" :class="`${ !scope.row.economicGroupActive ? 'c-nmidtwo' : '' }`" small/>
                    <span :class="`${ !scope.row.economicGroupActive ? 'c-nmidtwo' : 'c-ndarkfour' } break-name medium`">
                        {{ scope.row.name | formatName }}
                    </span>
                </div>
            </template>
        </el-table-column>

        <el-table-column prop="buyers" sortable :sort-method="sortColumnBuyers" min-width="60">
            <template slot="header">
                <el-tooltip content="Quantidade de compradores" placement="top">
                    <span>FILIAIS</span>
                </el-tooltip>
            </template>
            <template slot-scope="scope">
                <span :class="`${ !scope.row.economicGroupActive ? 'c-nmidtwo' : 'c-ndarkfour' } medium`">
                    {{ scope.row.buyers.length }} {{ scope.row.buyers.length > 1 ? 'filiais' : 'filial' }}
                </span>
            </template>
        </el-table-column>

        <el-table-column prop="partnerId" min-width="60" v-if="!USER_TYPE_MIXIN.isBackOffice">
            <template slot="header">
                <span>PARCEIRO</span>
            </template>
            <template slot-scope="scope">
                <span :class="`${ !scope.row.economicGroupActive ? 'c-nmidtwo' : 'c-ndarkfour' } medium`">
                    {{ getPartners[scope.row.partnerId] }}
                </span>
            </template>
        </el-table-column>

        <el-table-column prop="orderFomentationRequest" min-width="180">
            <template slot-scope="scope">
                <div class="d-flex justify-content-end">
                    <el-dropdown trigger="click">
                        <Button type="secondary" size="small" :color="getPrimaryColor">Ações</Button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <router-link :class="`${getPrimaryColor} c-ndarkthree medium`" :to="$route.path.includes('/provider/') ? `/group/${scope.row.id}/edit` : `group/${scope.row.id}/edit`">
                                    <Edit/>Editar dados
                                </router-link>
                            </el-dropdown-item>

                            <el-dropdown-item v-if="$store.state.group.groups.find(({id}) => id ==scope.row.id).buyers.length > 0">
                                <router-link :class="`${getPrimaryColor} c-ndarkthree medium`" :to="$route.path.includes('/provider/') ? {path: `/user/group/${scope.row.id}`, query: {route: '/group'}} : {path: `user/group/${scope.row.id}`, query: {route: '/group'}}">
                                    <div @click="$store.commit('group/setGroup', scope.row)">
                                        <UsersIcon size="16" color="#A1A8B8"/>Gerenciar usuários
                                    </div>
                                </router-link>
                            </el-dropdown-item>

                            <el-dropdown-item divided>
                                <router-link :class="`${getPrimaryColor} c-ndarkthree medium`" :to="$route.path.includes('/provider/') ? `/group/${scope.row.id}/edit/buyer` : `group/${scope.row.id}/edit/buyer`">
                                    <Providers class="mr-2" size="16" color="#A1A8B8"/>Gerenciar filiais
                                </router-link>
                            </el-dropdown-item>

                            <el-dropdown-item>
                                <router-link :class="`${getPrimaryColor} c-ndarkthree medium`" :to="$route.path.includes('/provider/') ? `/group/${scope.row.id}/edit/provider` : `group/${scope.row.id}/edit/provider`">
                                    <Financiers class="mr-2" size="16" color="#A1A8B8"/>Gerenciar cedentes
                                </router-link>
                            </el-dropdown-item>

                            <el-dropdown-item>
                                <router-link :class="`${getPrimaryColor} c-ndarkthree medium`" :to="$route.path.includes('/provider/') ? `/group/${scope.row.id}/edit/setting` : `group/${scope.row.id}/edit/setting`">
                                    <Settings />Regras da operação
                                </router-link>
                            </el-dropdown-item>

                            <el-dropdown-item divided v-if="!USER_TYPE_MIXIN.isBackOffice">
                                <span :class="`${getPrimaryColor} c-ndarkthree medium pl-3 pr-4 mr-2 d-flex align-items-center`" @click="handleActivationChange(scope.row)">
                                    <CheckPayment size="20" class="mr-n1" color="#A1A8B8" v-if="!scope.row.economicGroupActive"/>
                                    <Delete :strokeWidth="1.5" color="#A1A8B8" v-else/>
                                    <span class="ml-2">{{ !scope.row.economicGroupActive ? 'Ativar grupo econômico' : 'Desativar grupo econômico' }}</span>
                                </span>
                            </el-dropdown-item>

                            <el-dropdown-item :divided="USER_TYPE_MIXIN.isBackOffice ? true : false">
                                <div class="pl-3 c-sredfour medium" @click="handleDeleteGroup(scope.row.id)">
                                    <Trash color="#E54949" class="mr-2"/>Excluir
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </template>
        </el-table-column>
    </el-table>
    <GroupDelete :dialogVisible="dialogVisible" @closeModal="dialogVisible = $event" @deleteGroup="requestDeleteGroup"/>
    <EconomicGroupDeactivate :dialogVisible="dialogDeactivateVisible" @closeModal="dialogDeactivateVisible = $event" @deactivateGroup="changeGroupActivation(groupToChangeActivation)"/>
</div>
</template>

<script>
import Providers from '@/components/icons/Providers'
import Financiers from '@/components/icons/Assignor'
import NameInitials from '@/components/icons/NameInitials'
import Trash from '@/components/icons/Trash'
import Edit from '@/components/icons/Edit'
import Settings from '@/components/icons/Settings'
import Delete from '@/components/icons/Delete'
import CheckPayment from '@/components/icons/CheckPayment'
import GroupDelete from '@/components/modals/GroupDelete'
import EconomicGroupDeactivate from '@/components/modals/EconomicGroupDeactivate'
import deleteEconomicGroup from '@/api/deleteEconomicGroup'
import updateEconomicGroupActivation from '@/api/updateEconomicGroupActivation'
import UsersIcon from '@/components/icons/Users'

export default {
    props: {
        tableData: {
            required: true
        },
    },
    components: {
        Providers,
        Financiers,
        NameInitials,
        Trash,
        Edit,
        Settings,
        GroupDelete,
        CheckPayment,
        Delete,
        EconomicGroupDeactivate,
        UsersIcon,
    },
    data() {
        return {
            dialogVisible: false,
            dialogDeactivateVisible: false,
            groupToChangeActivation: {},
            groupIdToDelete: '',
            routeFromIsEditProvider: false,
        }
    },
    methods: {
        // sortColumnProviders(a, b) {
        //     return a.providers.length - b.providers.length
        // }, 
        sortColumnBuyers(a, b) {
            return a.buyers.length - b.buyers.length
        },
        sortColumnName(a, b) {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        },
        handleDeleteGroup(id) {
            this.groupIdToDelete = id
            this.dialogVisible = true
        },
        async requestDeleteGroup() {
            const result = await deleteEconomicGroup(this.groupIdToDelete)
            if (result.data.ok) {
                this.$emit('groupDeleted')
            }
            this.dialogVisible = false
        },
        gotoDetails(row, column) {
            this.$emit('persistFilter')
            if (column.label) {
                this.$router.push(`group/${row.id}/edit`)
            }
        },
        async handleActivationChange(row) {
            this.groupToChangeActivation = row
            if (row.economicGroupActive) {
                this.dialogDeactivateVisible = true
            } else {
                this.changeGroupActivation(row)
            }
        },
        async changeGroupActivation(row) {
            this.dialogDeactivateVisible = false
            const result = await updateEconomicGroupActivation(row.id, { economicGroupActivation: !row.economicGroupActive })
            if (result.data.ok) {
                this.$notify({
                    title: `Grupo econômico ${ row.economicGroupActive ? 'desativado' : 'ativado' } com sucesso!`,
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                });
            }
            row.economicGroupActive = !row.economicGroupActive
        }
    },
}
</script>

<style lang="scss" scoped>
.partner-icon {
    stroke: none !important;
}
.el-table .el-table__body-wrapper .el-table__body tbody .el-table__row td .cell .el-dropdown {
    text-align: end !important;
}
</style>